import { Alert, AlertTitle, Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Error401 = () => {
  const navigate = useNavigate()

  return (
    <Alert severity="warning" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height:'calc(100vh - 50px)'}}>
        <AlertTitle>403 Forbidden</AlertTitle>
        You are not allowed to access this page
        <Button size="small" color="warning" variant="contained" onClick={() => navigate('/')}>Go back to homepage</Button>
    </Alert>
  )
}

export default Error401